import { DocumentManagerRoot } from "@src/components/modules/DocumentManager/DocumentManagerRoot";
import { useDocumentManager } from "@src/components/modules/DocumentManager/useDocumentManager";
import { useVendorPortalDocumentUpload } from "@src/components/modules/Upload/useDocumentUpload";
import React, { useCallback, useState } from "react";
import { DocumentManagerProps } from "./DocumentManager";

export function VendorPortalDocumentManager({
  error,
  existingDocs,
  onDocsChanged,
  onDocsAdded: externalOnDocsAdded,
  onDocRemoved,
  onClose,
  bare = false,
  className,
  documentManagerRef,
  forceDocumentTypes,
}: DocumentManagerProps & {
  forCompanyId: string;
}) {
  const { attachedDocs, addDocs, removeDoc } = useDocumentManager({
    existingDocs,
    onDocsChanged,
    onDocRemoved,
    onDocsAdded: externalOnDocsAdded,
  });

  const { addFiles, loading } = useVendorPortalDocumentUpload();

  const [activeDocument, setActiveDocument] = useState<{
    displayName: string;
    id: string;
  } | null>(null);

  const onDocsAdded = useCallback(
    async (docs: File[]) => {
      const newDocs = await addFiles({ files: docs, forceDocumentTypes });
      addDocs(
        newDocs.map((d) => ({
          ...d,
          selected: true,
        })),
      );
      externalOnDocsAdded?.(newDocs.map((d) => d));
    },
    [addFiles, addDocs, externalOnDocsAdded, forceDocumentTypes],
  );

  return (
    <DocumentManagerRoot
      disablePreview={true}
      error={error}
      className={`${error ? "field-error" : ""} ${className ?? ""}`}
      onDocsAdded={onDocsAdded}
      loading={loading}
      bare={bare}
      onClose={onClose}
      attachedDocs={attachedDocs}
      onRemoveDoc={removeDoc}
      onDocumentPreviewClose={() => setActiveDocument(null)}
      onDocumentSelected={(doc) => {
        setActiveDocument({
          displayName: doc.displayName,
          id: doc.id,
        });
      }}
      activeDocument={activeDocument ?? undefined}
      documentManagerRef={documentManagerRef}
    />
  );
}
